import React, {
  useState,
  useRef,
  useEffect,
  useCallback,
  useContext,
} from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import "react-toastify/dist/ReactToastify.css";
import service from "../services/authservices";
import { ScaleLoader } from "react-spinners";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { UserContext } from "../contexts/UserContext";
import i18n from "../translate/i18n";
const HistoryAll = () => {
  const { t } = useTranslation();

  const [loader, setLoader] = useState(false);
  const [botBalance, setbotBalance] = useState([]);

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  useEffect(() => {
    if (i18nextLngs === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
    }
  }, [i18nextLngs]);

  useEffect(() => {
    fetchBalance();
  }, [0]);

  const fetchBalance = async () => {
    setLoader(true);
    const response = await service.getExchangeBalance();
    if (response.status) {
      setLoader(false);
      setbotBalance(response.data);
    } else {
      // console.error("Failed to fetch bot history:", response.Message);
      setLoader(false);
    }
  };

  return (
    <>
      <section>
        <Header />
      </section>
      <div className="withdraw-section">
        <div className="container">
          <div className="row prof_row_sm">
            <div className="col-lg-3 dispaly_none_1200">
              <Sidebar />
            </div>

            <div className="col-xl-9 col-lg-12 deposit_pad_top">
              <span className="profile_span">{t("ExchangesBalance")}</span>
              <div className="col-md-12 col-lg-12 verfication_kyc_col">
                <div className="pad-l-r">
                  <section className="asset_section asset_section_bottrade">
                    <>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="secuirty_box">
                            <div className="secuirty_box_contentsub deposit_contentsub">
                              <div className="table_section home_recent_table">
                                <div
                                  className="table_boxcontainer"
                                  style={{ height: "max-content" }}
                                >
                                  <table>
                                    <thead>
                                      <tr>
                                        <th>{t("Exchange")}</th>
                                        <th>{t("SpotBalance")}</th>
                                        <th>{t("Data&Time")}</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {loader ? (
                                        <tr>
                                          <td
                                            colSpan="5"
                                            style={{
                                              textAlign: "center",
                                              padding: "20px",
                                            }}
                                          >
                                            <div className="loader_main loader_mainChange">
                                              <ScaleLoader
                                                color="#20A1FD"
                                                height={10}
                                                width={3}
                                              />
                                              <p>{t("Loading")}</p>
                                            </div>
                                          </td>
                                        </tr>
                                      ) : botBalance.length > 0 ? (
                                        botBalance[0].binance_status == true ? (
                                          <tr>
                                            <td>{t("Binance")}</td>
                                            <td>
                                              {parseFloat(
                                                botBalance[0].binance_balance
                                              ).toFixed(2)}
                                            </td>
                                            <td>
                                              {moment(
                                                botBalance[0].updated_at
                                              ).format("lll")}
                                            </td>
                                          </tr>
                                        ) : botBalance[0].kucoin_status ==
                                          true ? (
                                          <tr>
                                            <td>{t("Kucoin")}</td>
                                            <td>
                                              {parseFloat(
                                                botBalance[0].kucoin_balance
                                              ).toFixed(2)}
                                            </td>
                                            <td>
                                              {moment(
                                                botBalance[0].updated_at
                                              ).format("lll")}
                                            </td>
                                          </tr>
                                        ) : botBalance[0].gateio_status ==
                                          true ? (
                                          <tr>
                                            <td>{t("Gateio")}</td>
                                            <td>
                                              {parseFloat(
                                                botBalance[0].gateio_balance
                                              ).toFixed(2)}
                                            </td>
                                            <td>
                                              {moment(
                                                botBalance[0].updated_at
                                              ).format("lll")}
                                            </td>
                                          </tr>
                                        ) : botBalance[0].bybit_status ==
                                          true ? (
                                          <tr>
                                            <td>{t("Bybit")}</td>
                                            <td>
                                              {parseFloat(
                                                botBalance[0].bybit_balance
                                              ).toFixed(2)}
                                            </td>
                                            <td>
                                              {moment(
                                                botBalance[0].updated_at
                                              ).format("lll")}
                                            </td>
                                          </tr>
                                        ) : (
                                          ""
                                        )
                                      ) : (
                                        <tr>
                                          <td
                                            colSpan="3"
                                            style={{ textAlign: "center" }}
                                          >
                                            <span className="depo_no_record">
                                              {t("NoDataFound")}
                                            </span>
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HistoryAll;
